import { FC, useRef, useState } from 'react';
import cx from 'classnames';
import { NavLink, NavLinkProps } from 'react-router';
import { Tooltip } from '@legacy/components/mui-components/Tooltip';
import { useIsThereRoomForTheText } from './truncatedNavLinkHookHelper';
import styles from './TruncatedNavLink.module.scss';

export interface TruncatedNavLinkProps extends NavLinkProps {
  className: string;
  children?: React.ReactNode;
}

export const TruncatedNavLink: FC<TruncatedNavLinkProps> = ({
  className,
  ...props
}) => {
  const textRef = useRef<HTMLAnchorElement>(null);
  const [ellipsisIsActive, setEllipsisIsActive] = useState(false);
  const stylesObject = cx([styles.Text, className]);

  useIsThereRoomForTheText(textRef, ellipsisIsActive, setEllipsisIsActive);

  return ellipsisIsActive ? (
    <Tooltip title={props.children} disableInteractive>
      <NavLink className={stylesObject} ref={textRef} {...props} />
    </Tooltip>
  ) : (
    <NavLink className={stylesObject} ref={textRef} {...props} />
  );
};
